import { useSelector } from 'react-redux'
import { stepSearchFocusSelector } from '../selectors'

export function useStepSearchFocus() {
  return useSelector(stepSearchFocusSelector)
}
